export default "__VITE_ASSET__BGhMo$Ys__"